import { render, staticRenderFns } from "./OPDetailProvider.vue?vue&type=template&id=7c56c1c3&"
import script from "./OPDetailProvider.vue?vue&type=script&lang=js&"
export * from "./OPDetailProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports